import { render, staticRenderFns } from "./OrderDeposit.vue?vue&type=template&id=f42dd352&"
import script from "./OrderDeposit.vue?vue&type=script&lang=ts&"
export * from "./OrderDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports